import { EventTypes, Location, Venue, User } from "sweet-global";

export const RESET_VENUES = "venue/RESET_VENUES";
export const GET_VENUES_INIT = "venue/GET_VENUES_INIT";
export const GET_VENUES_SUCCESS = "venue/GET_VENUES_SUCCESS";
export const GET_VENUES_FAILURE = "venue/GET_VENUES_FAILURE";
export const GET_MY_VENUES_INIT = "venue/GET_MY_VENUES_INIT";
export const GET_MY_VENUES_SUCCESS = "venue/GET_MY_VENUES_SUCCESS";
export const GET_MY_VENUES_FAILURE = "venue/GET_MY_VENUES_FAILURE";
export const CREATE_VENUE_INIT = "venue/CREATE_VENUE_INIT";
export const CREATE_VENUE_SUCCESS = "venue/CREATE_VENUE_SUCCESS";
export const CREATE_VENUE_FAILURE = "venue/CREATE_VENUE_FAILURE";
export const UPDATE_VENUE_INIT = "venue/UPDATE_VENUE_INIT";
export const UPDATE_VENUE_SUCCESS = "venue/UPDATE_VENUE_SUCCESS";
export const UPDATE_VENUE_FAILURE = "venue/UPDATE_VENUE_FAILURE";
export const DELETE_VENUE_INIT = "venue/DELETE_VENUE_INIT";
export const DELETE_VENUE_SUCCESS = "venue/DELETE_VENUE_SUCCESS";
export const DELETE_VENUE_FAILURE = "venue/DELETE_VENUE_FAILURE";
export const LINK_STRIPE = "venue/LINK_STRIPE";

export interface VenuesState {
  myVenues: {
    [venueId: string]: Venue;
  };
  venues: { [venueId: string]: Venue };
  venueUsers: {
    [venueId: string]: { [userId: string]: User };
  };
  isGettingMyVenues: boolean;
  successGettingMyVenues: boolean;
  errorGettingMyVenues: Error | null;
  isGettingVenues: boolean;
  successGettingVenues: boolean;
  errorGettingVenues: Error | null;
  isCreatingVenue: boolean;
  successCreatingVenue: boolean;
  errorCreatingVenue: Error | null;
  isUpdatingVenue: boolean;
  successUpdatingVenue: boolean;
  errorUpdatingVenue: Error | null;
  isDeletingVenue: boolean;
  successDeletingVenue: boolean;
  errorDeletingVenue: Error | null;
  linkStripe: string | null;
}

interface ResetVenuesAction {
  type: typeof RESET_VENUES;
}

interface LinkStripeAction {
  type: typeof LINK_STRIPE;
  state: string;
}

interface GetMyVenuesInitAction {
  type: typeof GET_MY_VENUES_INIT;
}

interface GetMyVenuesSuccessAction {
  type: typeof GET_MY_VENUES_SUCCESS;
  venues: {
    [venueId: string]: Venue;
  };
  venueUsers: {
    [venueId: string]: { [userId: string]: User };
  };
}

interface GetMyVenuesFailureAction {
  type: typeof GET_MY_VENUES_FAILURE;
  error: Error;
}

interface GetVenuesInitAction {
  type: typeof GET_VENUES_INIT;
}

interface GetVenuesSuccessAction {
  type: typeof GET_VENUES_SUCCESS;
  venues: {
    [venueId: string]: Venue;
  };
  venueUsers: {
    [venueId: string]: { [userId: string]: User };
  };
}

interface GetVenuesFailureAction {
  type: typeof GET_VENUES_FAILURE;
  error: Error;
}

interface CreateVenueInitAction {
  type: typeof CREATE_VENUE_INIT;
}

interface CreateVenueSuccessAction {
  type: typeof CREATE_VENUE_SUCCESS;
  venueId: string;
  venueEntity: Venue;
}

interface CreateVenueFailureAction {
  type: typeof CREATE_VENUE_FAILURE;
  error: Error;
}

interface UpdateVenueInitAction {
  type: typeof UPDATE_VENUE_INIT;
}

interface UpdateVenueSuccessAction {
  type: typeof UPDATE_VENUE_SUCCESS;
  venueId: string;
  venue: Venue;
}

interface UpdateVenueFailureAction {
  type: typeof UPDATE_VENUE_FAILURE;
  error: Error;
}

interface DeleteVenueInitAction {
  type: typeof DELETE_VENUE_INIT;
}

interface DeleteVenueSuccessAction {
  type: typeof DELETE_VENUE_SUCCESS;
  venueId: string;
}

interface DeleteVenueFailureAction {
  type: typeof DELETE_VENUE_FAILURE;
  error: Error;
}

export type VenuesActionTypes =
  | ResetVenuesAction
  | GetMyVenuesInitAction
  | GetMyVenuesSuccessAction
  | GetMyVenuesFailureAction
  | GetVenuesInitAction
  | GetVenuesSuccessAction
  | GetVenuesFailureAction
  | CreateVenueInitAction
  | CreateVenueSuccessAction
  | CreateVenueFailureAction
  | UpdateVenueInitAction
  | UpdateVenueSuccessAction
  | UpdateVenueFailureAction
  | DeleteVenueInitAction
  | DeleteVenueSuccessAction
  | DeleteVenueFailureAction
  | LinkStripeAction;
